import { ChangeEvent } from "react";
import { ToggleButton } from "@/components/buttons/ToggleButton";
import { useIsAuth } from "@/common/hooks";
import "./styles/ReportStepTwo.scss";

interface IProps {
  comment: string;
  onChangeComment: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  isCanContact: boolean;
  handleIsCanContact: () => void;
  report: () => void;
}

export const ReportStepTwo = (props: IProps) => {
  const {
    comment,
    onChangeComment,
    isCanContact,
    handleIsCanContact,
  } = props;

  const isAuth = useIsAuth();

  return (
    <div className="ReportStepTwo">
      <p className="ReportStepTwo-Text">Is there anything else you'd like to add?</p>
      <textarea
        className="ReportStepTwo-TextArea"
        value={comment}
        placeholder="Please add your comment here"
        onChange={onChangeComment}
        rows={3}
      />
      {isAuth && (
        <div className="ReportStepTwo-CheckWrap">
          <ToggleButton
            checked={isCanContact}
            label="Can we contact you for more information?"
            onChange={handleIsCanContact}
          />
        </div>
      )}
    </div>
  );
};
